import React from "react";
import { Divider, Avatar } from "@mui/material";

const PatientInfoGync = (props) => {
  console.log(
    "Props11",
    props.patientDetails
  );
  return (
    <div className="w-full">
      {props.patientDetails && props.patientDetails !== null ? (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 border border-gray-300 gap-2 text-[14px] bg-gray-100 rounded-md p-[10px]">
          <div className=" flex gap-2 space-x-2">
            <p className=" font-semibold w-[100px] text-blue-900">
              Patient Name
            </p>
            <p>:</p>
            <p className="text-blue-900">
              {props?.patientDetails?.patientName||props?.patientDetails?.["Patient Name"]}
            </p>
          </div>
          <div className=" flex gap-2 space-x-2">
            <p className=" font-semibold w-[100px]">UHID</p>
            <p>:</p>
            <p className="text-gray-500"> {props?.patientDetails?.uhid||props?.patientDetails?.UHID}</p>
          </div>
          <div className=" flex gap-2 space-x-2 ">
            <p className=" font-semibold  w-[100px]">Age/Gender </p>
            <p>:</p>
            <p className="text-gray-500">
              {props?.patientDetails?.age} /
              {props?.patientDetails?.gender?.charAt(0)}
            </p>
          </div>
          <div className=" flex gap-2 space-x-2">
            <p className=" font-semibold w-[100px]">Department </p>
            <p>:</p>
            <p className="text-gray-500">
              {props?.patientDetails?.department
                ? props?.patientDetails?.department
                : "-"}
            </p>
          </div>
          <div className=" flex gap-2 space-x-2">
            <p className=" font-semibold  w-[100px]">Doctor </p>
            <p>:</p>
            <p className="text-gray-500">
              {props?.patientDetails?.doctor
                ? props?.patientDetails?.doctor
                : "-"}
            </p>
          </div>

          {/* //Blood Group// */}
          {/* {props?.patientDetails?.department === "Obst. & Gynaecology"   ? (  */}
          <div className="flex items-center overflow-x-clip">
            <div className=" flex gap-2 space-x-2">
              <p className=" font-semibold  w-[100px]">Blood Group </p>
              <p>:</p>
              <span
                className={`capitalize ml-1 p-1 text-[13px] rounded-md font-semibold ${(["A-", "B-", "AB-", "O-"].includes(props.patientInfoApi?.bloodGroup) ||
                  ["A-", "B-", "AB-", "O-"].includes(props.bloodgroupValue))
                  ? "bg-red-500 text-white"
                  : (["A+", "B+", "AB+", "O+"].includes(props.patientInfoApi?.bloodGroup) ||
                    ["A+", "B+", "AB+", "O+"].includes(props.bloodgroupValue))
                    ? "bg-green-500 text-white"
                    : ""
                  }`}
              >


                {props.bloodgroupValue === "" || props.bloodgroupValue === null ? props.patientInfoApi?.bloodGroup : props.bloodgroupValue}

              </span>
            </div>
          </div>
          {/* ):("")} */}
          {props?.patientDetails?.referredByDoctor !== null && props?.patientDetails?.referredByDoctor !== undefined && props?.patientDetails?.referredByDoctor !== "-" && (
            <div className=" flex gap-2  space-x-2">
              <p className="font-semibold  w-[100px]">Referral Doc. </p>
              <p>:</p>
              <p className="text-gray-500">
                {props?.patientDetails?.referredByDoctor !== null ? props?.patientDetails?.referredByDoctor : "-"}
              </p>
            </div>)}
        </div>
      ) : (
        <div className="bg-white shadow-md px-2 py-6">
          <h1 className="w-full text-center">Patient Info Not Available</h1>
        </div>
      )}
    </div>
  );
};

export default PatientInfoGync;
